export default {
  language: 'en',
  morequerytext1: 'More Inquiries',
  morequerytext12: '查询其他客票',
  morequerytext2: '没有找到要退改的机票（测试环境非人脸）',
  reminder1: 'Notes',
  reminder2: 'Notes：',
  writeText1: 'Please enter the correct document number.',
  writeText2:
    'For more ticket inquiries, please visit the mini-program or China Southern Airlines App.',
  writeText_3:
    '您好，为保障行程信息安全，需进行实名认证后方可对身份证关联客票进行退改操作，请确认是否继续。',
  writeText3:
    'Hello, to ensure the security of your travel information, facial recognition verification is required before refund or change operations can be performed on tickets linked to your ID card. Please confirm whether to proceed.',
  writeText4:
    'Hello, to prevent financial risks, facial recognition is required for further inquiries. Please update to the latest version of the APP to proceed. Thank you.',
  inputText: 'Please enter your information.',
  labeltext1: 'ID number：',
  labeltext2: 'The surname：',
  labeltext3: 'The name：',
  labeltext4: 'The surname',
  labeltext5: 'The name',
  writeTip2: 'Please enter the ID number',
  writeTip3: 'Please enter your surname.',
  writeTip312: '乘机人的姓',
  writeTip322: '乘机人的名',
  writeTip4: 'Please enter your given name.',
  writeTip4qw: 'name contains special characters',
  writeTip466: 'Search',
  writeTip5:
    'As your name contains special characters, please reselect and confirm your name information.',
  writeTip6: 'Length cannot exceed 20 characters.',
  wxFaceCheck: 'WeChat real-name authentication',
  inpTip1:
    'Please fill in your information to complete real-name verification.',
  inpTip2: 'Please enter your surname/given name.',
  idNum: 'ID No.',
  openFaceCheck: '开启人脸识别',
  tip1:
    "Friendly reminder: If your name contains '·', please check the 'Name contains special characters' option. The system will add '·' between your surname and given name for verification; otherwise, verification will fail.",
  tip2:
    '1、The range of flights eligible for free changes in case of flight delays/cancellations is subject to actual conditions.',
  tip3:
    '2、The change calculation result is only the service fee; actual changes may require payment of a fare difference.',
  tip4:
    "3、The above refund and change instructions are for reference only. Please refer to China Southern Airlines' actual regulations.",
  tip5:
    "The above refund and change instructions are for reference only. Please refer to China Southern Airlines' actual regulations.",
  lookAgin: 'View Again',
  realName: 'Real-Name Verification',
  calculateR: 'Refund Calculation',
  calculateC: 'Change Calculation',
  refunMen: 'Refund Segments',
  leg: 'Leg',
  detailsR: 'Refundable Amount Details',
  amount: 'Ticket Fare',
  tax: 'Refundable Taxes and Fees',
  insurPremium: 'Insurance Fee',
  noinsurPremium: 'Non-Refundable Insurance Fee',
  handlingFee: 'Refund handling fee',
  coupon: 'discount coupon',
  refundableAmount: 'Refundable Amount',
  confirm: 'OK',
  applicableLeg: 'Applicable Segments',
  rules: 'Rules',
  CostDisplay: 'Fee Display',
  dateNow: 'Calculated based on current time',
  cFee: 'Change handling fee',
  tipRefun:
    'When changing your ticket, you may need to pay a fare difference depending on the new flight and cabin class you select.',
  clickTip: 'Click the bottom button to view detailed fees.',
  receivedR: 'Refunded',
  receivedU: 'Used',
  receivedC: 'Changed',
  unavailable: 'Unavailable',
  seleLeg: 'Select Change',
  refundLeg: 'Refund Segments',
  rulesFC: 'Rules for refund and change',
  rulesdetailed: 'Detailed Rules',
  choose: 'Select',
  chooseMore: 'More Options',
  name: 'Name',
  ticketNo: 'Ticket No.',
  taxes: 'Taxes',
  otherTicketses: 'Other Ticket Refund and Change Calculations',
  ticketnoInp: 'Please enter the ticket number or document number.',
  ticketNoID: 'Ticket No. / ID No.',
  passengerName: "Please enter the passenger's name",
  inpTip3: 'Please enter the actual operating flight number (e.g., CZ605).',
  flightNo: 'Flight number',
  flightDate: 'flight date',
  tip6:
    '1、Currently, only e-tickets for domestic flights operated by China Southern Airlines (starting with 784) are supported.；',
  tip7:
    '2、Team tickets, mileage redemption tickets, government procurement tickets, courtesy tickets, etc., are not currently supported.',
  tip8:
    '3、If your ticket cannot be queried for refund or change fees, it may be outside our current service coverage. We apologize for any inconvenience! You may contact the original ticketing service provider or China Southern Airlines customer service at 95539 for assistance.',
  nextStep: 'Next',
  openCard: 'Card Issuance Document',
  cardNo: 'ID number',
  cardNoBin: 'bank card BIN',
  checkMessage: '请核对填写公务卡开卡信息',
  titel1: 'Seat Selection & Check-In',
  titel2: 'Airport Transfer',
  titel3: 'Valet Parking',
  titel4: 'VIP Lounge',
  titel5: 'Extra Luggage',
  titel6: 'Pre-Sale of Multiple Seats for One Person',
  paySuccess: 'Payment completed',
  changeNo: 'Change order No.:',
  titelTip:
    'Friendly reminder: The system is processing your change request. For specific progress, please check the order details. If you have other questions, please call 95539.',
  goback: 'Return to Refundable & Alterable',
  details1: 'View Order Details',
  PleaseEnter: 'Please enter',
  cardholder: 'Cardholder',
  carddetails: 'Bank card information under your name (UnionPay only)',
  placeChoose:
    "Please select (the refund will be credited to the cardholder's account)",
  placeChoose123: 'Please select the ',
  placeHoder: 'Please select (please enter a 16-19-digit bank card number)',
  certification: 'Verification',
  failure: 'The verification of the account for refund has failed.',
  failureCardNo: 'The bank card information you provided is incorrect.',
  checkAgin: 'Please check it carefully!',
  Understood: 'Understood',
  successCer: 'Refund Account Verification Successful',
  cardNum: 'Card No.',
  cardNum2: 'Card Nunber',
  adult: 'Adult',
  child: 'Child',
  body: 'Infant',
  army: 'disabled servicemen',
  police: "disabled people's policemen",
  mileage: 'Mileage',
  mileageJ: '积分',
  ticketFee: 'Fare',
  mileageValue: '抵扣金额',
  refundInsurance: 'Refundable premium',
  airportTaxFee: 'Airport tax',
  fuelFee: 'Fuel surcharge difference',
  fuelFee123: 'Fuel surcharge',
  otherFee: 'Other Taxes',
  HandlingFee: 'Handling fees',
  costTotal: 'Fare difference',
  airportTaxFeedif: 'Airport tax difference',
  missfee: 'No-Show Fee',
  extensionfee: 'Extension Fee',
  qtPrice: 'Other Taxes',
  difference: 'Tax Difference',
  changeCost: 'Change fees',
  refundCost: 'Recoverable amount',
  mileageF: 'Refundable Miles',
  pendingReview: 'To be reviewed',
  Issued: 'Issued',
  Reserved: 'Scheduled',
  unreserved: 'Not Scheduled',
  ProcessingFailed: 'failed to process',
  InvoiceTitle: 'Invoice title:',
  TaxpayerIdentNum: '纳税人识别号:',
  phonenum: '收票人手机号:',
  email: 'Recipient‘s email:',
  Sunday: '(Sunday)',
  Monday: '(Monday)',
  Tuesday: '(Tuesday)',
  Wednesday: '(Wednesday)',
  Thursday: '(Thursday)',
  Friday: '(Friday)',
  Saturday: '(Saturday)',
  dateWorm: '(Incorrect Date)',
  Sunday1: 'Sun.',
  Monday1: 'Mon.',
  Tuesday1: 'Tues.',
  Wednesday1: 'Wed.',
  Thursday1: 'Thur.',
  Friday1: 'Fri.',
  Saturday1: 'Sat.',
  dateWorm1: 'Incorrect Date',
  one: '1st',
  two: '2nd',
  three: '3rd',
  four: '4th',
  five: '5th',
  six: '6th',
  seven: '7th',
  the: 'The',
  voyageleg: 'Segment',
  cabin: 'cabin',
  share: 'Share',
  highspeed: 'High-speed rail ',
  bullet_train: '动车 ',
  Intercity_railway: '城际铁路 ',
  afterChange: 'After Change',
  oldTitle: 'Original Flight',
  ni: 'ID No.',
  ni2: 'ID No.',
  pp: 'Passport No.',
  othersId: 'Other documents：',
  booklet: 'Household Register：',
  certificate: 'Birth Certificate：',
  Officer_Cert: 'Military Officer ID：',
  Police_Cert: 'Police Officer ID：',
  Taiwan_Cert: 'Taiwan Compatriot Permit：',
  home_Cert: 'Home Visit Permit：',
  Taiwan_permit: 'Taiwan Resident Residence Permit：',
  hk_mac: 'Hong Kong and Macau Resident Residence Permit：',
  Passport: 'Passport：',
  others: 'Other：',
  ForeignersId: 'Permanent Residence Permit for Foreigners：',
  Seafarer_Cert: "Seafarer's Certificate：",
  Exit_Permit: 'Exit-Entry Permit for Foreigners：',
  others2: 'Other Documents：',
  Passport2: 'Passport',
  e_passport: 'Electronic Passport',
  household_register: 'Household Register',
  mp_Cert: '军人及武警证件',
  passId: '通行证',
  others3: 'Other Documents',
  ForeignersID: 'Permanent Residence Permit for Foreigners',
  seaman_book: "Seafarer's Certificate",
  china_issued: '外交部签发的驻华外交人员证',
  Officer_ID: 'Military Officer ID',
  hkmtId: '港澳台居民居住证',
  others4: 'Other Documents',
  hkmaId: '港澳通行证',
  twId: '大陆居民来往台湾通行证',
  Sergeant_Cert: '士官证',
  certificate2: '出生医学证明',
  student_ID: 'Student ID',
  noNewTicketNo: '(No New Ticket Number Assigned Yet)',
  NewTicketNum: 'New ticket number',
  ticketNum: 'Ticket No.：',
  PassengerInfo: 'Passenger information',
  TermsOfUse: 'Instructions for use',
  tipcoup1:
    'As your change service fee requires manual calculation, the coupon deduction amount will be determined based on the coupon usage conditions and manual calculation results. For detailed calculation rules, please refer to the coupon usage conditions.',
  tipcoup2:
    'As your refund service fee requires manual calculation, the coupon deduction amount will be determined based on the coupon usage conditions and manual calculation results. For detailed calculation rules, please refer to the coupon usage conditions.',
  Contact: 'Contact information',
  Contact123: 'Please enter the contact person',
  name2: 'Name：',
  name2123: 'Document Number：',
  Contact_phone: 'Mobile：',
  bank_card: 'Bank Card',
  addNewCard: 'Add New Card',
  Seat_number: 'Seat Number',
  operation: 'Handling',
  ChangeSeats: 'Reselect Seat',
  SeatsTip1: 'Reserving a seat for you on the aircraft...',
  SeatsTip2: 'Seat reservation failed!',
  SeatsC: 'Seat Selection',
  SeatsTip3: 'The system has assigned you the following seat:',
  SeatsTip4: 'Seat reservation successful!',
  refundTip1: '自身原因无法成行，同意扣除退票手续费',
  refundTip2: '航空公司原因无法成行，申请全额退票',
  tipP1:
    'Due to busy business, please submit your request first to enter the review stage.',
  tipP2: '审核通过后，变更费用将在订单详情中进行显示',
  tipP3:
    'Hello, foreign currency tickets are currently not supported on the mini-program, H5, or APP. Please visit the official website to proceed. Thank you.',
  tipP4: (a, b) => {
    return `${a} to be deducted for this change ${b} Km. If the transaction fails, the system will refund the ${a} in full`;
  },
  tipP5:
    'Your ticket was not issued through our app. Changes or refunds must be handled through the original booking channel.',
  changeNo2: 'Change order No.：',
  cancelNo: 'Itinerary cancellation order number：',
  refundNo: 'Refund Number：',
  changeFee: 'Change fees：',
  refundFee: 'Amount to Refund：',
  loading1: '正在加载...',
  newChangeNo: 'New Change Number：',
  doorFee: '专车应退金额',
  tipT1:
    'Note: High-speed rail products are refunded to the original payment method by default.',
  titelE1: 'E-Invoice Issuance',
  titelE2: 'Additional product',
  titelE3: 'View refund details',
  titelE4:
    '*Note: If the refund fails, you can go to the details page and re-initiate the refund.',
  Zhang: 'Sheet(s)',
  flie1: 'Attachment uploaded successfully.',
  flie2: 'Submitted!',
  flie3: 'Attachment upload failed. Please upload again.',
  flie4: 'Pull down to refresh',
  flie5: 'Refreshing',
  flie6: 'Loaded successfully',
  flie7:
    "Your ticket was not purchased through China Southern Airlines' official channels. The refundable amount has been returned to the original payment account. The actual refund amount is subject to the original ticketing channel's refund policy. For details, please contact the original ticketing channel.",
  flie8: 'Green Flight - On Demand Dining',
  choosed: 'Selected',
  unit: 'Portion(s)',
  gift: 'Gift',
  Einvoice: 'E-invoice',
  resubmit: 'Resubmit',
  Cancel: 'Cancel',
  pay: 'Pay',
  complete: 'Complete',
  modify: '修改退票原因',
  modifyRefun: '退票原因',
  chooseRefun: '请选择退票原因',
  submit: 'Submit ',
  good: '好的',
  UnderReview: 'Reviewing',
  notApproved: 'Disapproved',
  Canceled: 'Cancelled',
  Canceled123: '可取消',
  progress1: 'Your change request has been cancelled. If you have any doubts, ',
  progress2:
    'please contact our online customer service for consultation or the original ticketing location for processing.',
  progress3: 'Unpaid',
  progress4: '支付中',
  progress5: 'Payment failed',
  progress6: 'Automatically processing',
  progress7: 'Change failed',
  progress8:
    'We apologize, your change request failed to process. Please contact China Southern Airlines',
  progress9: ' customer service at 95539 for assistance.',
  progress0: 'Successfully',
  progress10: 'Manually processing',
  progress11: 'Submit the order again',
  progressTip1: 'Change abandoned',
  progressTip2: 'Notified by phone',
  progressTip3: 'Wait for processing',
  progressTip4: 'Handling',
  progressTip5: 'Processing failed',
  progressTip6:
    'Change Failed: We apologize, your change request failed to process.',
  progressTip7: 'Disapproved',
  progressTip8: 'Refund being processed',
  progressTip9: 'Refund completed',
  progressTip0: 'Abnormal refund',
  progressTip10: 'Wait for processing',
  progressT1: 'Refund Processing',
  progressT2: 'Refund completed',
  progressT3: 'Closed',
  progressT4: 'Your refund request has been closed. If you have any questions,',
  progressT5: 'please contact China Southern Customer service at 95539',
  progressT6: 'Itinerary cancellation failed',
  progressT7:
    'please contact the online customer service for consultation and processing.',
  progressT8: 'Itinerary cancelled successfully',
  progressT9: 'Handling',
  progressT91: 'Refundable & Alterable',
  progressT92: 'Refunded/changed',
  progressT0:
    'Your refund request has been canceled. If you have any questions,',
  progressT10: 'Change review',
  progressT11: 'Handling the change',
  progressTips1: 'Handled',
  progressTips2:
    'Please contact our online customer service for consultation or the original ticketing location for processing.',
  progressTips3: 'Unpaid  Please complete payment as soon as possible.',
  progressTips4: 'Please complete the payment before the deadline.',
  progressTips5: 'Payment failed  Please make payment again.',
  progressTips6:
    'Payment failed，Please complete the payment before the deadline.',
  progressTips7:
    'Processing is expected to take 2 minutes. Please wait patiently.',
  progressTips8: 'To be handled',
  progressTips9: 'Please wait',
  progressTips0: 'To be confirmed by phone',
  progressTips10:
    "China Southern's customer service center will call the contact person later, please make sure your phone stays connected.",
  progressTips11:
    'the contact person did not answer the phone or replied that no change is required. If you have any questions, please contact our online customer service for consultation.',
  progressTips12:
    'The customer service has notified the contact person by phone. The contact person needs to confirm again when they return. If further handling is required, please contact the online customer service for consultation and processing.',
  progresswTip1: 'Refund review',
  progresswTip2: 'Accepted by bank',
  progresswTip3: 'Refund Acceptance',
  progresswTip4: 'Refund received',
  progresswTip5: 'Voucher Credited',
  progresswTip6: 'Refund Processing',
  progresswTip7:
    'If you have any objection to the audit result, please update the attachment as required and submit again for review.',
  progresswTip8: 'Please contact the original issuing channel for processing',
  progresswTip9: a => {
    return `The refund is expected to arrive in your bank account before ${a}`;
  },
  progresswTip10:
    'The refund is expected to arrive in 3 working days after being accepted by the bank ',
  progresswTip11:
    "call the bank's customer service center if you do not receive it after the due date",
  progresskl1: '若未查询到代金券到账，请联系南航客服95539。',
  progresskl2:
    "The card number verification failed during refunding, please click <span style='color: rgba(0, 138, 203, 1)' >[Verify again]</span> below",
  progresskl3:
    'The review is expected to take 1-5 business days. Please wait patiently.',
  progresskl4: 'View progress',
  progresskl5:
    'Mileage refund exception. Please contact online customer service or the original ticketing channel for assistance.',
  progresskl544: '里程退款失败',
  refundMoth: 'Refund method',
  inpIdCard: 'Enter bank card number (UnionPay only)',
  choosePerson: 'Select the cardholder',
  inpMessage: "Enter the cardholder's name",
  inpMessage2: "Enter the cardholder's ID number",
  inpIdCard2: 'Enter the bank card number',
  cardtip:
    "The cardholder must match the passenger's document number and name to proceed. If the ID card name contains special characters, such as '.', please enter them as they are; otherwise, real-name verification will fail.",
  refundMoth1: 'province',
  refundMoth2: 'Enter the province where the bank card account is opened',
  refundMoth3:
    'Enter the exact province where the opening bank is located，For example: Guangdong Province',
  refundMoth4: 'City',
  refundMoth4567: 'The address to open the account',
  refundMoth5: 'Enter the city where the bank card account is opened',
  refundMoth6:
    'Enter the exact city where the opening bank is located，For example: Guangzhou',
  refundMoth7: 'Enter the address of the opening bank',
  refundMoth8:
    'Enter the exact address of the opening bank to make sure the refund can be received，For example: Guangzhou XXXX sub branch',
  refundMoth9: 'Bank-registered mobile number',
  refundMoth0: 'Enter the mobile number registered with the bank',
  refundMoth11: 'Enter verification code',
  checkCode: 'Get Verification Code',
  refundMoth12: 'I Understand',
  refundMoth13:
    'Hello, your ticket cannot be handled automatically , the application will be transferred to the original ticket issuing channel for processing, please confirm whether to submit.',
  refundMoth14: 'Enter the mobile number',
  refundMoth15: 'Facial Recognition Prompt',
  refundMoth16:
    "Hello, to ensure the security of your funds, express refund requires facial recognition to verify the cardholder's identity. Please confirm whether to proceed.",
  refundMoth17: 'Go to Verify',
  refundMoth1765: '信息校验失败',
  refundMoth18:
    'Hello, to prevent financial risks, express refund requires facial recognition. Please update to the latest version of the APP to proceed. Thank you.',
  refundMoth19:
    'Hello, in order to ensure the safety of your funds, face recognition verification is required for speed refund. Please go to the official APP of China Southern Airlines or wechat mini program for refund operation, thank you.',
  refundMoth20:
    'The verification of the account for refund has failed. The bank card information you provided is incorrect. Please check it carefully!',
  refundMoth21:
    'The system is processing your refund request. Please wait! \n If submission fails, please try again later.',
  refundMoth22:
    'Hello, your ticket cannot be handled automatically , the application will be transferred to the original ticket issuing channel for processing, please confirm whether to submit.',
  refundMoth23: '3、机票款将以代金券形式退至您的南航账户。',
  refundMoth24:
    '3.机票款将以代金券形式退至您的南航账户，并额外获得一定面额机票优惠券奖励及额外里程奖励。',
  refundMoth25: a => {
    return `3、机票款将以代金券形式退至您的南航账户，并额外获得一定额度${a}奖励。`;
  },
  refundMoth26:
    '3、机票款将以代金券形式退至您的南航账户，并额外获得一定面额机票优惠券奖励。',
  refundMoth27:
    'Hello! If you refund your ticket, your rights and interests of China Southern Airlines Beijing Daxing unlimited package ticket will become invalid.',
  refundMoth28: 'Cancel refund',
  refundMoth29:
    'Hello! High-speed rail products cannot be refunded at this time. If you have any questions, please contact China Southern Airlines customer service at 95539.',
  refundMoth30: 'Continue Refunding Flight Ticket',
  refundMoth31:
    'After refund, any auction adjustment fees (if applicable) will be automatically refunded.',
  refundMoth32: 'Proceed with refund',
  refundMoth33:
    'Dear passenger, if you have companions, please check the box for the passenger on the refund application page and submit your identification documents together.',
  refundMoth34: a => {
    return `Hello, the valid date of the ticket is ${a} . Please submit the application for change or refund within the valid date of the ticket. Thank you.`;
  },
  refundMoth35: 'Submit again',
  refundMoth36: 'Please select a refund method.',
  refundMoth37:
    "Your ticket was not purchased through China Southern Airlines' official channels. The refundable amount has been returned to the original payment account. The actual refund amount is subject to the original ticketing channel's refund policy. For details, please contact the original ticketing channel.",
  refundMoth38:
    'You have not yet registered a China Southern Airlines account. This refund method is currently unavailable. Would you like to register now?',
  refundMoth39: 'Remind Me Later',
  refundMoth40: 'Register Now',
  refundMoth41:
    "Refund to China Southern Airlines account is only supported for the passenger's own account. Please confirm if this is your own operation.",
  refundMoth42: 'Other Refund Methods',
  refundMoth43:
    "<span style='color: #03bffd;'>Voucher：</span><span>China Southern Airlines Account<strong>Voucher</strong>Can be fully deducted when purchasing tickets, selecting seats, luggage allowance, VIP lounge, etc., for yourself or others through China Southern Airlines' official channels. It can also be split and used multiple times. Valid for 2 years from the date of refund.<strong>Non withdrawable</strong>。</span><br/>",
  refundMoth44: (a, b, c) => {
    return `<span style="color:#0096d5;">机票优惠券：</span><span>机票优惠券可在南航官方渠道购买机票时部分抵扣，不可拆分多次使用，仅限（会员号：${a}）本人使用，<strong>不可提现，不退不补</strong>。${
      !b && c ? ' 具体使用说明如下：' : ''
    }</span><br/>`;
  },
  refundMoth45: a => {
    return `<span style="color:#0096d5;">使用日期：</span><span>${a}</span><br/>`;
  },
  refundMoth46: a => {
    return `<span style="color:#0096d5;">适用业务：</span><span>${a}</span><br/>`;
  },
  refundMoth47: a => {
    return `<span style="color:#0096d5;">价格限制：</span><span>单次产品/服务不低于${a}元（含）可以使用</span><br/>`;
  },
  refundMoth48: 'Flight Date：',
  refundMoth49:
    'The departure dates of all flights in the order must fall within the following range:',
  refundMoth50: 'No restrictions',
  refundMoth51: 'Excluded Flight Dates:',
  refundMoth52: 'Coupons cannot be used for flights on the following dates:',
  refundMoth53: 'China Southern Airlines Account',
  refundMoth54: (a, b) => {
    return `<span style="color:#0096d5;">可用的航线：</span><span style="word-wrap: break-word;">${a}</span><br/>
        <span style="color:#0096d5;word-wrap: break-word;">航班号：</span><span style="word-wrap: break-word;">${b}</span><br/>`;
  },
  refundMoth55: (a, b) => {
    return `<span style="color:#0096d5;">适用舱位：</span><span>${a}</span><br/>
            <span style="color:#0096d5;">可用的支付方式： </span><span>仅限${b}</span><br/>
            <span style="color:#0096d5;">备注：</span><span>部分特殊产品不能使用优惠券</span><br/>`;
  },
  refundMoth56:
    '应退机票款将以<strong>代金券</strong>形式退至您的南航账户，并获得一定奖励。',
  refundMoth57: (a, b, c, d) => {
    return `${a}元机票款将以<strong>代金券</strong>
                  形式退至您的南航账户，并可获得${b}额外
                  ${c === 'Y' ? '积分' : '里程'}及
                  ${d}元机票优惠券奖励。`;
  },
  refundMoth58: '应退机票款将以<strong>代金券</strong>形式退至您的南航账户。',
  refundMoth59: (a, b, c) => {
    return `${a}元机票款将以<strong>代金券</strong>
                  形式退至您的南航账户，并可获得${b}额外
                  ${c === 'Y' ? '积分' : '里程'}奖励。`;
  },
  refundMoth60: (a, b) => {
    return `${a}元机票款将以<strong>代金券</strong>
                  形式退至您的南航账户，并获得${b}
                  元机票优惠券。`;
  },
  refundMoth61: 'Attachment upload failed',
  refundMoth62:
    'Note: Additional products are refunded to the original payment method by default.',
  refundMoth63:
    'This ticket was purchased through the Guanaitong channel. Part of the amount will be refunded to the Guanaitong account balance. The actual refund amount is subject to the credited amount.',
  refundMoth64: 'Additional Products Selected for Refund',
  refundMoth65: 'Itinerary cancelled',
  refundMoth66: 'Refund',
  refundMoth84: 'flight leg for refund',
  refundMoth67: 'Please provide the bank card number.',
  refundMoth68: "Please provide the cardholder's name.",
  refundMoth69:
    'To ensure financial safety, according to relevant laws and regulations, the ticket fare will be only refunded to the original payment card and it can only be done once. In the event of repeated refunding via multiple channels or other arbitrage attempts, China Southern and the ticket issuer will hold the relevant person responsible.',
  refundMoth71:
    'To ensure financial safety, according to relevant laws and regulations, the ticket fare will be only refunded to the passenger himself/herself and it can only be done once. In the event of repeated refunding via multiple channels or other arbitrage attempts, China Southern and the ticket issuer will hold the relevant person responsible.',
  refundMoth72: 'I have read and agree to the',
  refundMoth73: ' «Privacy Notice» ',
  refundMoth74: ' «General Conditions of Carriage for Passenger & Baggage» ',
  refundMoth75: '《International Conditions of Carriage》',
  refundMoth76: 'Refund to Original Payment Method',
  refundMoth77: 'Estimated to arrive in 3 working days',
  refundMoth78: 'Refund to bank card',
  refundMoth79: 'Real-time receipt',
  refundMoth80: 'Refund to China Southern Airlines Account',
  refundMoth81: 'Real-time receipt',
  refundMoth82: 'Extra Mileage and Coupon Rewards',
  refundMoth83: 'Extra Mileage Reward',
  refCupon1: 'Segment Selection',
  refCupon2: 'No restrictions',
  refCupon3: 'quick refund',
  refCupon4: 'Refund to Original Channel',
  refCupon5: (a, b) => {
    return `享受单次产品/服务免费，最高可抵${a}${b}`;
  },
  refCupon6: (a, b, c) => {
    return `享受单次产品/服务${Number(a) / 10}折，最高可抵${b}${c}`;
  },
  refCupon7: (a, b, c) => {
    return `单次产品/服务满${a}${b / (Number(c) / 100)}（含）可使用`;
  },
  refCupon8: '仅会员本人',
  refCupon9: '额外优惠券奖励',
  refCupon0: '仅会员本人及其受让人',
  refCupon11: '退票费券',
  refCupon12: '多品类券',
  refCupon13: '不满足航线限制',
  refCupon14: '不可与已选优惠券叠加使用',
  refCupon15: '机票',
  refCupon16: '选座',
  refCupon17: '行李',
  refCupon18: 'Meal',
  refCupon19: '休息室',
  refCupon20: '中转住宿',
  refCuponDoor: '接送机专车',
  refCupon21: 'PLUS会员',
  refCupon22: '免费变更',
  refCupon23: '候补升舱',
  refCupon24: '登机口升舱',
  refCupon25: 'Multiple Seats for One Person',
  refCupon26: '现场逾重行李',
  refCupon27: '套票',
  refCupon28: '机场贵宾服务',
  refCupon29: '现场升舱',
  refCupon30: '机票兑换K位',
  refCupon31: '优惠券不适用于该航段',
  refCupon32: '仅限实名认证会员使用',
  refCupon33: 'confirm',
  refCupon3354: 'return',
  refCupon34: '不可用原因',
  refCupon35: '使用期限：',
  refCupon36: '% off',
  refCupon37: '次',
  refCupon38: '使用说明',
  refCupon39: '优惠券号',
  refCupon40: '最高抵用',
  refCupon41: '价格限制',
  refCupon42: '适用业务',
  refCupon43: '航班时刻',
  refCupon44: '订单所选退票航段的航班时刻需在以下范围内：',
  refCupon45: '不限',
  refCupon46: '订单内所有航班的出发日期必须在以下日期范围内：',
  refCupon47: '不限实名认证会员',
  refCupon48: '限制实名认证会员使用',
  refCupon49: '适用航线',
  refCupon50: '可使用的退款方式',
  refCupon51: '退票时限',
  refCupon52: a => {
    return `仅限原航班起飞前${a}小时使用`;
  },
  refCupon53: a => {
    return `仅限原航班起飞后${a}小时使用`;
  },
  refCupon54: a => {
    return `仅限${a}舱位客票使用`;
  },
  refCupon55: a => {
    return `仅限付款渠道为${a}的客票使用`;
  },
  refCupon56: a => {
    return `仅${a}渠道使用`;
  },
  refCupon57: '舱位限制',
  refCupon58: '支付方式',
  refCupon59: '使用渠道',
  refCupon60: '退票场景',
  selectDate1: 'Continue',
  selectDate2: 'Reselect',
  selectDate22: '升舱',
  selectDate3: (a, b) => {
    return `您好！新航班日期在原航班日期前${a}天，后${b}天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。`;
  },
  selectDate33: (a, b) => {
    return `您好！新航班日期在原航班日期前${a}天，后${b}天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期符合非自愿变更日期范围，将按非自愿变更处理。点击【继续】，本次将按非自愿变更处理，如需升舱请点击【升舱】（存在升舱费用）`;
  },
  selectDate4:
    '温馨提示：因儿童或婴儿旅客不支持购买“加赠”产品，如继续办理将为所有乘客选择普通客票产品；如需将携带儿童或婴儿的旅客客票变更为“加赠”产品，请联系南航客服95539办理。',
  selectDate5: 'Departure date',
  selectDate51212: '您已选择',
  selectDate5121: '（组合）',
  selectDate512: '为您推荐',
  selectDate6: 'Sun.',
  selectDate7: 'Mon.',
  selectDate8: 'Tues.',
  selectDate9: 'Wed.',
  selectDate0: 'Thur.',
  selectDate11: 'Fri.',
  selectDate12: 'Sat.',
  selectDate13: '年',
  selectDate14: '月',
  selectDate15: 'today',
  selectDate16: (a, b) => {
    return `您好！新航班日期在原航班日期前${a}天，后${b}天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。`;
  },
  ticketChanges1: 'Week',
  ticketChanges2: 'All Dates',
  ticketChanges3: 'Refund and Change Rules',
  ticketChanges4: "Disabled People's Police",
  ticketChanges5: 'Disabled Military Personnel',
  ticketChanges6: a => {
    return `以下为${a}退改说明标注,仅供参考,请以实际情况为准`;
  },
  ticketChanges7: 'Free baggage allowance',
  ticketChanges8: 'Rules for Refund and Change of New Flights',
  ticketChanges9: 'Change fees',
  ticketChanges9123: 'Explanation of Change Fees',
  ticketChanges0: 'Change Fee/Time',
  ticketChanges022: 'Instructions',
  ticketChanges11: 'Change time',
  ticketChanges12: 'More than 24 hours before departure',
  ticketChanges13: 'Within 24 hours before departure',
  ticketChanges14: 'Detailed Explanation of Changes',
  ticketChanges15: 'Explanation of Refund Fee',
  ticketChanges16: 'Refund time',
  ticketChanges17: 'original ticket redemption miles',
  ticketChanges18: '50% of the original ticket redemption miles',
  ticketChanges19: 'Detailed Explanation of Refund',
  ticketChanges20: 'Additional notes',
  ticketChanges21: `<span>
                        客票变更后退票,所收的变更手续费不退,客票订座舱位更改后如
                      </span>
                      <span>
                        又发生退票,票价差部分按变更后新票价订座舱位手续费标准办
                      </span>
                      <span>
                        理,原票价按变更前订座舱位退票手续费标准办理，合计收取退
                      </span>
                      <span>票费，且原票变更手续费不退。</span>`,
  ticketChanges22: `<span>
                        If a ticket is refunded after a change, the change fee already collected is non-refundable.
                        If a refund is requested after changing the booking class, the fare difference portion will be refunded according to the rules of the new booking class, 
                        while the original fare portion will be refunded according to the rules of the original booking class. The refund fee will be calculated accordingly.
                        </span>
                        <span>
                        If both a change fee and a fare difference for an upgrade apply, both the change fee and the fare difference will be charged.
                        </span>`,
  ticketChanges23:
    'If a ticket is refunded after a change, the change fee already collected is non-refundable.',
  ticketChanges24: 'Sold out',
  ticketChanges25: 'Remaining seats inadequate',
  ticketChanges2589: 'Remaining seats inadequate',
  ticketChanges2512: 'Remaining tickets',
  ticketChanges26: 'Economy Class',
  ticketChanges27: 'Sky Pearl Economy Class',
  ticketChanges28: 'Business Class',
  ticketChanges281: 'First Class',
  ticketChanges29: 'Full fare',
  ticketChanges2943: 'Front seats offer wider spacing',
  ticketChanges294333: '退改条件及行李额',
  ticketChanges2935: 'Access to CZ VIP Lounge & Priority Airport Services',
  ticketChanges30: 'Discount on upgrade change fee',
  ticketChanges31: '额外获得',
  ticketChanges32: 'Free baggage allowance',
  ticketChanges33: 'Selected Flight',
  ticketChanges34: 'The',
  ticketChanges35: 'Segment',
  ticketChanges35j: 'Starting',
  ticketChanges35jf: 'Segments',
  ticketChanges36: 'Handling fee + fare difference',
  ticketChanges37: 'Fare difference',
  ticketChanges38: 'transfer：',
  ticketChanges39: 'Stay about',
  ticketChanges40: 'Meal included',
  ticketChanges41: 'No meals',
  ticketChanges42: 'stop over：',
  ticketChanges42a: 'Arrived the next day',
  ticketChanges43: a => {
    return `该航班为
            ${a}
            承运的南航代码共享航班，登机前请到
            ${a}
            值机柜台办理值机。`;
  },
  ticketChanges46: 'Actual Carrier',
  ticketChanges47: 'Hide',
  ticketChanges48: 'Expand',
  ticketChanges49: 'Flight details',
  ticketChanges50: a => {
    return `您好！新航班距离上一航班不足${a /
      60000}分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges5aa: a => {
    return `您好！新航班距离下一航班不足${a /
      60000}分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges51: (a, b, c) => {
    return `您好！新航班与上一航班衔接时间不足${
      a === true ? b : c
    }分钟，请选择其它航班。`;
  },
  ticketChanges53: (a, b, c) => {
    return `您好！新航班距离下一航班不足${
      a === 0 ? b : c
    }分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges54: (a, b, c) => {
    return `您好！新航班距离下一航班不足${
      a === true ? b : c
    }分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges55: (a, b, c) => {
    return `您好！新航班距离下一航班不足${
      a === 0 ? b : c
    }分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges56: (a, b, c) => {
    return `您好！新航班距离下一航班不足${
      a === true ? b : c
    }分钟，为了您的顺利出行，请选择其它航班。`;
  },
  ticketChanges57: (a, b) => {
    return `您好！新航班日期在原航班日期前${a}天，后${b}天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。`;
  },
  ticketChanges58: (a, b) => {
    return `起飞前${a}小时至${b}小时之内`;
  },
  ticketChanges59: (a, b) => {
    return `起飞后${a}小时至${b}小时之内`;
  },
  ticketChanges60: (a, b) => {
    return `起飞前${a}小时至起飞后${b}小时之内`;
  },
  ticketChanges61: a => {
    return `起飞前${a}小时之后`;
  },
  ticketChanges62: a => {
    return `起飞后${a}小时之外`;
  },
  ticketChanges63: a => {
    return `起飞前${a}小时之前`;
  },
  ticketChanges64: a => {
    return `起飞后${a}小时之内`;
  },
  ticketChanges65:
    'Online change to flights departing in the next 60 minutes is not allowed.',
  ticketChanges66:
    'This flight is approaching departure time. Please contact our online customer service for consultation or confirm with the check-in counter that you can still check in before making a reservation. Any costs incurred due to missed flights will be borne by you.',
  ticketChanges67: 'Agree and Continue',
  ticketChanges68:
    'If you change your flight to Beijing Capital International Airport, your privileges of unlimited package ticket with China Southern at Beijing Daxing International Airport will be invalid.',
  ticketChanges69:
    'If you change to a code-share flight, your privileges of unlimited package ticket with China Southern at Beijing Daxing International Airport will be invalid.',
  ticketChanges70: 'Change cancellation',
  ticketChanges71: 'Continue change',
  ticketChanges71a: (a, b) => {
    return `注：始发机场将变更为${a}，到达机场将变更为${b}，请务必确认`;
  },
  ticketChanges71s: a => {
    return `注：始发机场将变更为${a}，请务必确认`;
  },
  ticketChanges71d: a => {
    return `注：到达机场将变更为${a}，请务必确认`;
  },
  ticketChanges72: 'Origins of some flights changed to',
  ticketChanges73: 'Destinations of some flights changed to',
  ticketChanges74: 'Note the difference.',
  ticketChanges75: 'change',
  updateDetail0: 'Order No：',
  updateDetail1: 'Change order：',
  updateDetail2: 'Refund order：',
  updateDetail3: 'Ticket No:',
  updateDetail4: 'Fare (excluding taxes)',
  updateDetail5: 'Total Price : ',
  updateDetail6: 'Total Change Fee: ',
  updateDetail7: 'Amount to Refund : ',
  updateDetail8: 'Itinerary cancelled successfully',
  updateDetail9: 'Itinerary cancellation failed',
  updateDetail10: 'Submitted but not confirmed',
  updateDetail11: 'Confirmed pending refund',
  updateDetail12: 'Refunded',
  updateDetail13: 'Cancelled',
  updateDetail14: 'Adjusted',
  updateDetail15: 'Refunded',
  updateDetail16: 'Closed',
  updateDetail17: 'Accepted',
  updateDetail18: 'Handling',
  updateDetail19: 'Processing Failed',
  updateDetail21: 'Processing Successful',
  updateDetail22: 'Reviewing',
  updateDetail23: 'Disapproved',
  updateDetail24: 'Unpaid',
  updateDetail25: 'Payment failed',
  updateDetail26: 'Refund being processed',
  updateDetail27: 'Automatically processing',
  updateDetail28: 'Change failed',
  updateDetail29: 'Abnormal refund',
  updateDetail30: 'To be manually processed',
  updateDetail31: 'Manually processing',
  updateDetail32: 'To be confirmed by phone',
  updateDetail33: 'resubmit',
  updateDetail34: 'Change abandoned',
  updateDetail35: 'Notified by phone',
  updateDetail36: 'Changed successfully',
  updateDetail37: 'Refund completed',
  updateDetail38: 'Status error',
  updateDetail39:
    'Hello, foreign currency tickets are currently not supported on the mini-program, H5, or APP. Please visit the official website to proceed. Thank you.',
  updateDetail40: (a, b) => {
    return `本次变更需扣减${a}${b}公里，如交易失败系统将全额退还${a}。`;
  },
  updateDetail4122: 'Remarks',
  updateDetail41:
    'Voluntary changes may incur a service fee and fare difference. In case of flight delay or cancellation, one free change is allowed under applicable regulations.',
  updateDetail42:
    'When a ticket contains multiple usage rules, the strictest rule for the changed segment will apply. Change fees are charged per segment at the highest standard and per occurrence.',
  updateDetail43:
    "Ticket changes must be made within the ticket's validity period.",
  updateDetail44:
    'If the change fee is pending review, the actual change fee will be as stated in the SMS after review.',
  updateDetail45:
    'Voluntary refunds may incur a service fee. In case of flight delay or cancellation, unused segments can be refunded without a service fee under applicable regulations.',
  updateDetail46:
    'When a ticket contains multiple usage rules, the strictest rule for the entire journey will apply. If the ticket has been partially used, the refund will deduct the applicable fare and taxes for the used segments, along with any refund service fee and no-show fee (if applicable).',
  updateDetail47:
    'If the refund fee is pending review, the actual refund fee will be as stated in the SMS after review. Once submitted, the refund request cannot be canceled.',
  updateDetail48: 'All unused refundable segments must be refunded together.',
  updateDetail49:
    'Children aged 2-11 and infants occupying a seat are charged the same fees as adults for changes/refunds. Infants under 2 not occupying a seat are not charged for changes/refunds.',
  updateDetail50:
    "The above rules are for reference only. For other matters, please refer to China Southern Airlines' actual regulations. If you have any questions, please contact 95539.",
  updateDetail51: 'The itinerary has been cancelled',
  updateDetail52: 'Ticket No.',
  updateDetail53: 'For fees and more rules,',
  updateDetail54: "please see 'Refund and Change Rules'",
  updateDetail55: 'ID No.',
  updateDetail56: 'Change',
  updateDetail57: 'Refund',
  updateDetail5723: 'Handling fees：',
  updateDetail58: 'Pay',
  updateDetail59: 'Search by Ticket No. / ID No. / Name',
  updateDetail60: 'Incorrect ticket number, document number, or name.',
  updateDetail61: 'Re-Login',
  updateDetail63: 'Refunded/ Changed',
  updateDetail62:
    'Currently, you do not have any tickets eligible for refund or change.',
  updateDetail64: '抱歉！暂无法找到您可退改的客票。建议您先完成',
  updateDetail65: '您现在暂无可退改订单/客票',
  updateDetail66: 'No flights match your search.',
  updateDetail67: 'No eligible tickets/orders found yet.',
  updateDetail68: 'Click',
  updateDetail69: ' to inquire about more tickets.',
  updateDetail70: 'Flight Time',
  updateDetail71: 'Passenger Type',
  updateDetail72: 'This function has been disabled and cannot be accessed.',
  updateDetail73: 'Please enter mispurchase ticket information',
  updateDetail74: 'Please enter new ticket information',
  updateDetail75: 'Please select the mispurchase ticket purchase scenario',
  updateDetail76: 'Please enter the ticket number!',
  updateDetail77: 'Please enter the correct ticket number!',
  updateDetail78: 'Click to select a ticket or enter a ticket number',
  updateDetail79: '出发',
  updateDetail80: 'No search results available at the moment',
  updateDetail81: 'Querying...',
  updateDetail82: 'Mispurchase ticket',
  updateDetail83: 'Click to select a ticket or enter a new ticket number',
  updateDetail84: 'New ticket',
  updateDetail85: 'Mispurchase scenario',
  updateDetail86: 'Submit Request',
  updateDetail87: 'Refund/change',
  updateDetail88: 'Change Progress',
  updateDetail89: '取消行程进度',
  updateDetail90: 'Refund Progress',

  gender: 'Gender',
  nationality: 'Nationality',
  tipError: (a, b) => {
    return `旅客${a}的${b}格式错误`;
  },
  certiIssuing: 'Document Issuing Authority',
  supplement: a => {
    return `请补充旅客${a}的信息`;
  },
  suppleMessage: (a, b) => {
    return `请补充旅客${a}的${b}`;
  },
  passenger: 'Passenger',
  save: 'Save',
  SuppPsginfo: 'Supplement Passenger Information',
  male: 'Male',
  female: 'Female',
  selectDetailInfo: 'Please select details.',
  prePsgMessage:
    'Please confirm that the name entered matches the travel document.',
  mandatory: 'Required',
  dateBirth: 'Date of Birth',
  country: 'Country/Region',
  documentType: 'Document Type',
  Required: 'mandatory',
  validityPeriod: 'Document Expiry Date',
  additionalTip: '购买产品数量不可超过成人数量',
  additionalTip2: '该宝贝不能购买更多哦',
  additionalTip3: '选择休息室',
  checked: 'Selected',
  checked123: '/人起',
  recommends: 'Recommended Services for You',
  orderTotal: '订单总额',
  details: '明细',
  addPsgTip: 'Hello, this change requires supplementary passenger information.',
  replenish: 'Go to Supplement',
  replenish123: 'Please enter civil servant information',
  verifyTip:
    'Verification failed. Please try again later or contact online customer service for assistance.',
  verifyTip2:
    'The entered civil servant name does not match the change passenger. Please re-enter.',
  verifyTip3:
    'The entered bank card BIN number has an incorrect digit count. Please re-enter.',
  verifyTip4:
    'This change requires a deduction of XX miles. If the transaction fails, the system will fully refund the miles.',
  verifyTip5:
    'After a voluntary change, any auction adjustment fees (if applicable) will be automatically refunded.',
  verifyTip6:
    'After an involuntary change, the refundability of auction adjustment fees (if applicable) will be linked to the status of the new ticket.',
  chooseFood: '请选择是否机上用餐',
  yes: 'YES',
  no: 'NO',
  no123: 'Reward',
  foodSelect: a => {
    return `勾选“否”，取消机上用餐，获取${a}奖励`;
  },
  greenFlight: 'Green Flight',
  benefits: 'Equity benefits',
  civilMsg: 'Please enter civil servant information',
  foodPsg: 'Please select passengers who dine on flight',
  greenPsg: 'Please select green flight passengers',
  selectAll: 'Select All',
  submitChange: 'Submit Change request',
  inputPsgName: '请输入联系人姓名',
  telephone: 'Mobile',
  telephone123: '请输入联系手机',
  VerificationCode: 'Verification Code',
  rcRuleTip5: 'a fee may apply ',
  rcRuleTip6:
    'The final refund amount is subject to review. You will be notified via SMS after the review is approved. This is a voluntary refund; ',
  rcRuleTip1:
    'The final refund amount is subject to review. You will be notified via SMS after the review is approved. This is a voluntary refund; a fee may apply according to the rules.',
  rcRuleTip2:
    'The final refund amount is subject to review. You will be notified via SMS after the review is approved. This is an involuntary refund; no fee is charged.',
  rcRuleTip3:
    'This is a voluntary refund. A refund fee may apply according to the fare rules.',
  rcRuleTip4: 'This is an involuntary refund. No refund fee will be charged.',
  rfInstruction: 'Refund and Change Instructions',
  unused: 'Fully Unused',
  partiallyUsed: 'Partially Used',
  noChange: 'Non-Changeable',
  noRefund: 'Non-Refundable',
  referenceTip:
    'The above instructions are for reference only. Please refer to actual conditions.',
  officialCard:
    "refers to the first 6 digits of the official card number; for example, the BIN for ICBC's official card is 628288.",
  bankCardNo: 'Bank card BIN',
  inpuitCardholder: "Please enter the cardholder's name.",
  reCode2: 'Referral Code (Optional)',
  inputRecode: 'Please enter the employee referral code.',
  reCode1: 'Referral Code',
  segPsg: '/Leg/person',
  people: '/person',
  people123: 'person',
  fillInfo: 'Select the change information',
  gotoRc: 'Proceed to Refund and Change',
  queryTip3: '当前您没有已取消行程的订单',
  queryTip4: '当前您没有可办理取消行程的机票。',
  queryTip5: '未找到相关客票/订单信息',
  ticketN: 'Ticket No.：',
  ticketN123: 'Passenger',
  ticketNow: '当前',
  totalPrice: '总价：',
  totalChangeFee: '总变更费：',
  muTip: '该客票暂不支持自助取消行程，请联系东航客服95530处理。',
  caTip: '该客票暂不支持自助取消行程，请联系国航客服95583处理。',
  huTip: '该客票暂不支持自助取消行程，请联系海航客服95339处理。',
  psgTicNo: 'Ticket No.：',
  cancellationTip: '取消行程费用及更多规则，请查询“取消行程说明”',
  cancellationInt: '取消行程说明',
  reCertification: '重新认证',
  faceFail: '对不起，未通过实名认证',
  fail: 'Failed',
  faceSuccess: '恭喜您，通过实名认证',
  success: 'Successful',
  weekDay: 'Mon.,Tues.,Wed.,Thur.,Fri.,Sat.,Sun.',
  discountRecom: '优惠推荐',
  csair: 'China Southern Airlines',
  changeDes: 'Change Rules',
  refundDes: 'Refund Rules',
  close: 'Close',
  tikcetPrice: 'Ticket Fare: ',
  refundhfee: 'Current Refund Fee / Penalty: ',
  changehfee: 'Current Change Fee / Penalty: ',
  irefundRule:
    'The ticket meets the conditions for involuntary changes/refunds. Fees will be calculated according to the involuntary change/refund rules.',
  calTip1: 'Calculated based on the current time and as a voluntary refund.',
  calTip2: 'Calculated based on the current time and as a voluntary change.',
  immeRefund: 'Refund Now',
  changeSeg: '变更航程',
  cancelTip1:
    '若您的航程后续仍需出行，但出行时间待定，可取消行程，待出行时间确认后，对客票进行变更操作，变更手续费按当前取消行程时间计算。',
  cancelTip2: '取消行程后，将无法再乘坐本航班，且无法恢复。',
  costCal: 'Fee Calculation',
  percentage: 'Percentage Calculation',
  numerical: 'Numerical Calculation',
  process: 'Application Process',
  viewDe: 'View details',
  free: 'free',
  onlyTax: '仅退税费',
  front: 'before',
  timeNode: 'Time Frame',
  noTimeLimit: '不限制时间',
  couponTip8: '变更费券',
  couponTip10: '不满足价格限制',
  couponTip12: '与已选优惠券的支付方式不可同时使用',
  pSeat: '国内优选座位',
  speedyBoarding: '快速登机',
  couponInfo1: '因所选择机票变更手续费为0，无需使用优惠券',
  couponInfo5: '仅限会员本人使用',
  couponInfo6: '航班日期不符合条件',
  couponInfo9: '订单所选原航班的航班时刻需在以下范围内：',
  couponInfo11: '最高抵用',
  couponInfo12: '价格限制',
  couponInfo14: '用于变更时，可用于以下变更后舱位',
  couponInfo15: '当日变更',
  couponInfo16: '仅航班当天允许使用',
  couponInfo17: '可用的支付方式',
  couponInfo18: '变更时限',
  couponInfo22: '客票预定后',
  applicationDate: '适用日期',
  to: '至',
  except: '除外',
  outinHours: '小时之外',
  networkFail1: 'Your network seems unstable.',
  networkFail2: 'The server is busy. Please try again later.',
  discounted: '降价客票',
  discountedTip1: '请输入旧客票信息',
  discountedTip2: '请输入新客票信息',
  discountedTip6: '新旧客票号不能相同，请重新输入',
  oldTic: '旧客票',
  newTic: '新客票',
  login: '登录',
  idTikcetNo: '证件号或者票号',
  surnamePsg: '乘机人的姓氏',
  namePsg: '乘机人的名字',
  kindTip1: '1.请使用乘机人的姓名、证件号或者票号进行查询。',
  kindTip2:
    '2.变更适用于南航国内客票，以及航班不正常情况下的南航国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊客票除外。',
  kindTip3:
    '3.退票适用于南航国内客票，以及南航官网、APP、微信小程序、微信公众号、客服渠道购买的南航国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊客票除外。',
  kindTip4: '4.对于以上暂未支持自助退改的客票，请联系南航客服95539办理退改。',
  kindTip5:
    "Please use the passenger's name, ID number or ticket number, e.g.7840000000000 for inquiry",
  queryRc: '查询退改记录',
  confirmMsg: '请确认您的信息',
  invoice2: '纳税人识别号:',
  invoice3: '公司地址:',
  invoice4: '公司电话:',
  invoice5: '公司开户行:',
  invoice6: '公司账号:',
  invoice7: 'Recipient‘s mobile:',
  invoice9: '退票旅客:',
  invoice10: '请确认邮箱无误，电子发票将在系统开具后发送至您的邮箱，请注意查收',
  invoiceApoint: '提交发票预约信息',
  inputInvoice: '请输入您的电子发票信息',
  invoiceCont: 'Invoice content: Refund handling fee',
  invoiceType: 'Invoice type:',
  invoiceMsg1: '个人',
  invoiceMsg2: '企业',
  invoiceMsg3: '非企业性单位',
  invoiceMsg4: '选择发票抬头',
  invoiceMsg5: '请输入公司名称',
  invoiceMsg6: '请输入纳税人识别号',
  optional: 'optional',
  invoiceMsg7: '请输入联系人邮箱',
  invoiceMsg8: '请输入联系人手机',
  invoiceTip1: '为同行人开具:',
  invoiceTip2:
    '1.请您确认填写信息是否正确，邮箱请填写真实地址，否则将无法收到电子发票邮件！',
  invoiceTip3:
    '2.税总（2017）16号文件规定，2017年7月起，企业必须提供税号才能开票，否则不能作为报销凭据。',
  view: '查看',
  companyName: '公司名称',
  TaxCode: '纳税人识别码',
  companyAddress: '公司地址',
  companyPhone: '公司电话',
  openBank: '公司开户行',
  companyAccount: '公司账号',
  voiceTitle: '我的发票抬头',
  default: '默认',
  taxId: '税号:',
  addPsg: '添加同行人',
  selectDate: 'Change Flight Date',
  additional1: 'Please select the ancillary product(s) you wish to cancel.',
  additional2: '提交退票申请后，机票包含的',
  additional3: '将跟随机票一起作废，请谨慎操作。',
  trainTip1: a => {
    return `此为空铁联运订单，旅客${a}使用了火车票优惠券，机票与火车票需一起退订，谢谢`;
  },
  trainTip2: '此为空铁联运订单，机票与火车票需一起退订，谢谢',
  selectResaon: '请选择退票原因！',
  notCancel: '暂不取消',
  notCancel123: '确认取消',
  domestic: 'Domestic',
  international: 'International',
  additional5:
    'After the refund is completed, note how the limit is returned. If there is no return, you may log in to the Employee Travel zone to request the return limit.',
  firstJn: '第一程',
  firstJn12321: 'to',
  asd0: 'Voluntary refund',
  asd1: '个人原因',
  asd2: 'Involuntary refund',
  asd3: 'Flight Delay',
  asd4: 'Flight Cancellation',
  asd5: '航班超售',
  asd6: '航班变动',
  asd7: 'Other',

  inputTip1: 'The server is busy. Please try again later.',
  inputTip2: 'Please enter the contact person',
  inputTip3: 'Please enter the Mobile Number',
  inputTip4: '联系手机:',
  trainPrice: '高铁票价',
  trainHandFee: '高铁手续费',
  fareCost: 'Fare',
  fuelTaxTotal: 'Fuel surcharge difference',
  airportTaxTotal: 'Airport tax difference',
  premium: 'Refundable Insurance Fee',
  airportTax: 'Airport tax',
  fuelCost: 'Fuel surcharge',
  counterFee: 'Handling fee',
  refundCoupon: 'Refund coupon',
  totalTax: 'Refundable Taxes and Fees',
  ticketPrice: 'Fare',
  deductionMileage: 'Deduction mileage',
  mileageCharge: 'Mileage charge',
  discontedFee: 'Commission Charge Discount',
  retainUpgrades: '退票挽留升舱',
  mileageTxt:
    'Please log in the member mileage account to check the actual mileage',
  actualMileage: 'Refunded Miles',
  expiredMileage: 'Expired Miles',
  delayMileage: 'Extended Miles',
  actualExpired: 'Actual Expired Miles',
  reSubmitTip1: '提交退票申请后，机票包含的',
  reSubmitTip2: '将跟随机票一起作废，请谨慎操作。',
  reSubmitTip3:
    '1.The above mileage expiration information is for reference only.',
  reSubmitTip4:
    ' 2.The award miles refunded for involuntary ticket refunds will be extended for 6 months based on the original validity period',
  reSubmitTip5:
    ' 3.If the refunded miles have already expired, they will be considered invalid. Please refer to the actual credited amount.',
  reSubmitTip6: 'This is an involuntary refund. No refund fee will be charged.',
  reSubmitTip7:
    'This is a voluntary refund. A refund fee may apply according to the fare rules.',
  reSubmitTip8:
    'The final refund amount is subject to review. You will be notified via SMS after the review is approved. This is an involuntary refund; no fee is charged.',
  reSubmitTip9:
    "Due to high volume, your refund request is expected to be processed within 7 days. Fees will be calculated according to your ticket's conditions. The final refund amount is subject to review.",
  reSubmitTip10:
    '因疫情防控需要，请密切关注南航官网发布的特殊退改政策公告。需要办理特殊退改的客票，请联系原购票单位或者南航客服95539办理。',
  caRules: 'calculation rule',
  couponQuantity: '优惠券数量',
  couponperiod: '优惠券有效期',
  period: '有效期',
  mileageperiod: '里程有效期',
  aa: 'Sheet(s)',
  coValue: '优惠券面值',
  mileageLimit: '里程额度',
  limit: '额度',
  coCode: '优惠券券码',
  giveCou: '赠送优惠券',
  giveMileage: 'Free Mileage',
  feeInfo: 'Fee Information',
  addSvc: '附加服务',
  guaranteeSvc: '保障服务',
  trainFee: '应退高铁金额',
  expiredInfo: 'expiration information',
  expiredInfo123: '费用总计',
  voucher: 'Voucher',
  refundMileage: 'Refundable Miles',
  seletedCoupon: '已选优惠券',
  csairAccount: ' 南航账户',
  couponUseTip1:
    "Can be fully deducted when purchasing tickets, selecting seats, luggage allowance, VIP lounge, etc., for yourself or others through China Southern Airlines' official channels. It can also be split and used multiple times. Valid for 2 years from the date of refund.",
  couponUseTip2: '不可提现。',
  couponUseTip3: (a, b) => {
    return `可在南航官方渠道购买机票时部分抵扣，不可拆分多次使用，仅限
                  ${a}（卡号：${b}
                  ）本人使用，
                  <strong>不可提现，不退不补</strong>
                  ，使用规则以实际到账查询结果为准。`;
  },
  actualTrans: '实际承运',
  transportation1: '该航班为',
  transportation2: '承运的南航代码共享航班，登机前请到',
  transportation3: '值机柜台办理值机。',
  transportation4: '按住滑块,拖动完成拼图',
  transportation5: '请登录退改客票的购票人或乘机人帐号进行操作',
  tips: 'prompt',
  memberShip1: '诚邀非会员:',
  memberShip2: '申请加入南航会员明珠俱乐部,尊享会员权益',
  skip: '跳过',
  memberShip3: '单个文件名不超过150字',
  memberShip4: 'Fill in the information',
  memberShip5:
    'As your refund service fee requires manual calculation, the coupon deduction amount will be determined based on the coupon usage conditions and manual calculation results. For detailed calculation rules, please refer to the coupon usage conditions.',
  memberShip6: 'Please enter the Pearl member password',
  memberShip7:
    '由于银联系统对于姓名包含特殊符号暂时没有统一标准，认证失败可尝试取消特殊符号选项再试一次。',
  reInput: 're-enter.',
  feedback: 'I want feedback',
  manualService: '在线人工客服',
  onliveService: 'Online Support',
  automatic1: 'Loading automatically...',
  automatic2: 'Automatically processing...',
  additional: 'Additional product',
  addproducts: '增加产品',
  adjustment: '竞拍调整',
  copy: '1Portion(s)',
  trainTicket: '火车票',
  excessBaggage: 'Overheavy luggage',
  paidSeat: 'Paid seat selection',
  interval: '间',
  late: '晚',
  Processing1: 'Processing for you...',
  Processing2:
    "Your change request has been submitted. Please check the details or complete the payment later in the 'Processing' or 'Refunded/Changed' list. If you cannot find the relevant change request, please resubmit the change. Thank you.",
  Processing3:
    "Your refund request has been submitted. Please check later in the 'Processing' or 'Refunded/Changed' section. If you cannot find your refund request, please click the 'Refund' button again to apply for a ticket refund. Thank you.",
  progress: '进度条',
  veriTip1: 'Please enter the employee referral code.',
  veriTip2: 'The verification code entered is incorrect. Please re-enter it',
  veriTip3:
    'Please confirm that you are the person who will be taking the flight or have obtained the permission of the person who will be taking the flight to cancel the check-in. If not, you may be held legally responsible.<br/> Note: You will not be able to board the plane after successfully canceling the check-in.',
  checkTip1:
    'Note: You will not be able to board the flight after successfully canceling your check-in.',
  checkTip2:
    'Are you sure you want to cancel the check-in that has been completed?',
  seMethod: '选择“退款至南航账户”',
  rewardTip2: '享受额外权益奖励。',
  rewardTip3: '元机票优惠券',
  modify22: '前往修改',
  giveUp: 'Abandon',
  sureT: 'Refundable',
  sureTs: 'Refunded Miles',
  deleFile: 'Confirm to delete file',
  deleteS: 'The file has been deleted. You can upload it again',
  uploadF: 'Attachment upload',
  File: 'Attachment',
  zhengm: '请上传相关证明文件',
  as1: 'Special refund application',
  as2:
    'If you need to apply for special refund or change due to epidemic prevention or other diseases, please select the reason and upload relevant certification materials according to the guidelines or contact the original issuing unit for handling.',
  as3:
    'Dear passenger, if you have companions, please check the box for the passenger on the refund application page and submit your identification documents together.',
  as4: 'Epidemic prevention',
  as5: 'Application for special refund about medical reasons.',
  as6: 'Information',
  as7: 'Please upload the text version of the information picture',
  as8: 'Identity certificate',
  as9: 'Continue adding',
  as0: 'Documentation of the epidemic',
  as11:
    'Medical institution payment invoice or hospitalization deposit certificate',
  as12: 'Please upload both sides of your ID card',
  as13:
    'Please confirm that you are the person who will be taking the flight or have obtained the permission of the person who will be taking the flight to cancel the check-in. If not, you may be held legally responsible.<br/> Note: You will not be able to board the plane after successfully canceling the check-in.',
  as14:
    'Note: You will not be able to board the flight after successfully canceling your check-in.',
  as15: 'Select Flights',
  load11: 'Loading',
  loginFail: '登录失效',
  timeOut: '网络超时',
  yichang: 'Network connection error',
  title: 'Notes',
  title_delay: 'Flight Delay/Cancellation',
  title_explain: '退改说明',
  title_Confirm_error: 'Submission Failed',
  applicationSubmission: 'Submit request',
  back: 'Back',
  okBtn: 'OK',
  cancel: 'Cancel',
  goon: '继续',
  myOrder: 'My Orders',
  goonRefund: 'Continue Refund',
  goonChange: 'Continue Change',
  quitChange: 'Abandon Change',
  allsubmit: 'Submit Together',
  ressubmit: 'Resubmit',
  yes: '是',
  no: '否',
  keepsubmit: 'Continue Submission',
  orderStatusChange:
    'Hello! The status of the current change request has been updated and can no longer be processed for payment.',
  cardBin: '银行卡Bin',
  cardBinMsg: '是指公务卡卡号的前6位;</br>例如:工行的公务卡卡Bin是628288</br>',
  updateDetail: {
    title: 'Notes',
    content:
      '您好！需先进行实名认证，您可以在移动端按以下任一方式认证：</br></br>1、南航APP首页—我—在线实名认证；</br>2、南航官网首页—服务大厅—在线实名验证；',
    noticket: '您好！根据您输入的信息，未找到可退改的客票，请重新输入。',
    cancelOrder: 'Hello! Are you sure you want to cancel this change request? ',
    cancelOrderOk: '取消变更成功！',
    cancelOrderFailed:
      '抱歉！暂时无法取消变更。请稍后重试或联系南航客服95539。',
    costCalculation: '费用计算',
    huChangeTip:
      '本渠道仅支持该客票办理自愿变更，若想办理航班不正常改签，请前往海航官网或者APP进行办理，如有疑问请联系在线客服或海航客服95339',
  },
  endorsedApply: {
    addPsgSuccess: '添加同行人成功',
    OneAdult: '您好！该旅客已进行过航班改期，后续将以改期的航班时间进行变更。',
    ManyAdult:
      '您好！该旅客已进行过航班改期，本次变更仅限航班时间相同的旅客，航班时间不同的旅客们需分别申请变更。',
    flightDelayOrCancel:
      "<p>1.国内客票可免费变更航班日期前后7天内（含航班当天）的航班。</p><p style='margin: 0.2rem 0;'>2.国际客票可免费变更航班日期前7天、后14天（含航班当天）的航班。</p><p>3.头等舱、公务舱、明珠经济舱、经济舱全价票可选航班日期不受此限制。</p>",
    needSelectPsg: {
      content: '您好！添加同行人需先选择乘机人。',
    },
    pleaseSelectChangeFlightAndPsg:
      'Please select the flight segment and passenger(s) you wish to change first!',
    pleaseSelectRefundFlightAndPsg:
      'Please select the flight segment and passenger(s) you wish to refund first!',
    pleaseSelectChangeFlight:
      'Please select the flight segment you wish to change first!',
    pleaseSelectRefundFlight:
      'Please select the flight segment you wish to refund first!',
    pleaseSelectTrainFlight:
      '您好！若需单独退订高铁产品，可通过 “我的订单” - “假期” - “高铁订单” 操作退款',
    pleaseSelectPsg: '请您先勾选乘机人！',
    pleaseSelectHtlight:
      '您好！若需单独退订酒店产品，可通过“我的订单-酒店”操作退款',
    selectedPsgMustHasAdult:
      'Hello! Separate changes for children are not currently supported. If you have any questions, please contact China Southern Airlines customer service at 95539 for assistance.',
    selectedPsgbady:
      '您好！暂不支持单独婴儿自助变更。如有疑问，请联系南航客服95539处理。',
    selectedFlightError(text) {
      return `您好！${text}的航班需要勾选后方可进行一下步操作，请确定是否勾选该行段？`;
    },
    selectedFlightSuccess:
      'Selection successful. Please select the flight date for the next segment!!',
    onlySelectOneAdultInTAOrder:
      '您好，此类型客票仅允许选择一个成人乘机人进行退票操作！',
    cancelCheckIn: 'Check-in cancellation',
    selectMutiplePerson: '该产品同一订单的乘机人需同时退改，请勾选所有乘机人。',
  },
  selectDateObj: {
    selectedFlightDateBefore:
      'Hello! The selected date cannot be earlier than the previous flight date. Please select a new date.',
    selectedFlightDateAfter:
      'Hello! The selected date cannot be later than the subsequent flight date. Please select a new date.',
    selectedFlightDateBeyondWQT:
      'This date does not qualify for discounted change fees. Please confirm if you still wish to change the date.',
    selectedFlightDateSeasonTicket:
      '本期双城旅行产品旅行截止日期为2023年1月5日。您选择变更后的航班日期，后续产品保障不足90日。是否继续？',
    selectedFlightDateExceeds:
      '抱歉! 中转运价客票要求航班衔接时间不得大于24小时, 请重新选择',
    selectMuFlightDate:
      '您好！新航班日期在原航班日期前3天，后3天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。',
  },
  ticketChanges: {
    optionalFlight:
      '您好！当天除您已订的航班外，无其它可选航班，建议您重新选择日期，如有疑问，请联系在线客服咨询或原出票地办理。',
    electionFlight:
      '您有一段航班是处于重选状态，请选择完毕再进行其它航班重选！',
    checkpending:
      '本次变更的费用需要人工审核，在您选择完新航班并提交申请后，客服稍后短信通知您审核结果及变更费用。',
    changeCabin_1:
      '您好，该航班的明珠经济舱剩余座位不足或售罄，是否变更至经济舱？',
    changeCabin_2: '您好，该航班无明珠经济舱，是否变更至经济舱？',
    compareCabin(text) {
      return `您所选舱位为降舱变更，已兑换${text}不退还。`;
    },
  },
  addPersonMessage: {
    afterSaleChangeConfirm_ok: {
      title: '提交成功',
      content: '',
    },
    afterSaleChangeConfirm_error:
      "非常抱歉的通知您, 您的改签申请提交失败。 原因可能是您所选航班座位已售空， 或同时改签人数过多造成系统改签出错。你可以拔打<a href='tel://95539 '> <u>95539</u></a>人工服务垂询。",
    afterSaleChangeConfirm_fail: {
      title: '提示',
      content: '',
    },
  },
  applySubmit: {
    inputContactInfo: {
      content: '请输入并保存联系人信息',
    },
    inputRightContactInfo: 'Hello! Please enter a valid mobile number.',
    verificationCode: '请输入六位验证码！',
    afterSaleChangeReqPayOK_error:
      '尊敬的旅客，您好！本次变更提交失败，您可以重新提交或拨打南航客服95539处理。',
    afterSaleRefundApp_error:
      '尊敬的旅客，您好！退票申请中遇到问题，请重新提交或联系南航客服95539处理。',
    checkTips_fzy:
      "<strong style='color:#262626;'>We will finish reviewing the refund as soon as possible and notify you by SMS.</strong><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.<br/>2. This is an involuntary refund. No refund fee will be charged.</div>",
    bingtui_zy:
      "<strong style='color:#262626;'>We will finish reviewing the refund as soon as possible and notify you by SMS.</strong><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.<br/>2、您将提交病退申请，若您的材料符合要求，将为您免费办理退票；若您的材料不符合要求，系统将按自愿退票规则进行办理，自愿退票手续费可通过服务大厅“退改计算器”模块查看或联系客服咨询。</div>",
    checkTips_zy:
      "<strong style='color:#262626;'>Hello, we will complete the refund review as soon as possible and notify you via SMS.</strong><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/><span>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.</span><br/>2. This is a voluntary refund, and corresponding refund fees may apply according to the refund and change rules.</div>",
    checkTips_zy_lessFare: contentProps => {
      if (contentProps.isDomestic) {
        return `<strong style='color:#262626;'>Hello, we will complete the refund review as soon as possible and notify you via SMS.</strong><div>
            <div class="lessFare_tips_area">
              <div class="lessFare_tipsT">
                <span>Recoverable amount</span>
                <span>${contentProps.curr + contentProps.totalCosts}</span>
              </div>
              <div class="lessFare_tips">
                <span>Fare</span>
                <span>${contentProps.curr + contentProps.ticketCosts}</span>
              </div>
              <div class="lessFare_tips">
                <span>Airport tax</span>
                <span>${contentProps.curr + contentProps.airTaxCosts}</span>
              </div>
              <div class="lessFare_tips">
                <span>Fuel surcharge</span>
                <span>${contentProps.curr + contentProps.ryTaxCosts}</span>
              </div>
              <div class="lessFare_tips">
                <span>Handling fees</span>
                <span>${contentProps.curr +
                  '-' +
                  contentProps.totalCharge}</span>
              </div>
            </div>
          </div><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/><span>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.</span><br/>2. This is a voluntary refund, and corresponding refund fees may apply according to the refund and change rules.</div>`;
      } else {
        return `<strong style='color:#262626;'>Hello, we will complete the refund review as soon as possible and notify you via SMS.</strong><div>
            <div class="lessFare_tips_area">
              <div class="lessFare_tipsT">
                <span>Recoverable amount</span>
                <span>${contentProps.curr + contentProps.totalCosts}</span>
              </div>
              <div class="lessFare_tips">
                <span>Fare</span>
                <span>${contentProps.curr + contentProps.ticketCosts}</span>
              </div>
              <div class="lessFare_tips">
                <span>Refundable Taxes and Fees</span>
                <span>${contentProps.curr + contentProps.totalTaxCosts}</span>
              </div>
              <div class="lessFare_tips">
                <span>Handling fees</span>
                <span>${contentProps.curr +
                  '-' +
                  contentProps.totalCharge}</span>
              </div>
            </div>
          </div><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/><span>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.</span><br/>2. This is a voluntary refund, and corresponding refund fees may apply according to the refund and change rules.</div>`;
      }
    },
    checkTips_pengdingzy:
      "<strong style='color:#262626;'>Hello, we will complete the refund review as soon as possible and notify you via SMS.</strong><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/><span>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.</span><br/>2. This is a voluntary refund, and corresponding refund fees may apply according to the refund and change rules.<br/><span style='color:#e5004a'>3. The actual refund fee will be manually reviewed according to the ticket usage rules. After the manual review is completed, the refund will be processed directly.</span> As the refund fee may be relatively high, if you are unaware of the calculation rules for the refund fee, it is recommended to contact the original ticketing channel or China Southern Airlines customer service for consultation before submitting.</div>",
    yddqTip:
      "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/>1、您提交退票后原定座位将被取消，实际退还金额将以审核结果为准；<br/>2、本次因疫情原因申请的退票需要人工审核。如符合疫情文件，退票将按非自愿退票，免收退票手续费；如不符合疫情文件，退票将按自愿退票，按照客票使用条件可能产生相应退票手续费。</div>",
    quotaTip:
      "<span style='color:#e5004a'>额度将在退票后几分钟内到账（若超出额度数不予退回），若未到账，可通过员工旅行-返回额度申请</span>",
    contact_important: 'Please complete the contact information.',
    error_certno: '请输入证件号',
    error_certnoF: '请输入正确的证件号',
    error_name: '请输入持卡人',
    no_verification: '请输入验证码！',
    get_verification: '请获取验证码！',
    error_verification: '您输入的验证码有误，请重新输入。',
    overtime_verification: '您输入的验证码已超时，请重新获取。',
    eleven_phone: '请输入11位国内手机号。 ',
    isCheckedRead: 'Please read and agree to the Service Agreement',
    artificial:
      'Hello! This change requires manual review. Our customer service will notify you of the review result and any change fees via SMS shortly.',
    error_cardNo: '抱歉，您输入的银行卡信息有误，请重新输入。',
    no_bankcard: '请输入16-19位银行卡号',
    error_referral: '推荐码格式不正确！',
    changeCabin:
      '尊敬的旅客，您选择新航班的明珠经济舱已售罄，系统将自动为您安排同航班经济舱座位。<br/>变更成功后，您可前往南航机场柜台领取明珠经济舱体验券。<br/>请确认是否继续提交？',
    happyFlying:
      '您好！按照南航套票产品规则：机票一旦出票，不得变更、不得签转。',
    repeat: '文件名重复，无法上传，请更名后上传',
    selectedError:
      '附件上传格式为Word（.doc/.docx/.DOC/.DOCX）、Excel（.xls/.xlsx/.XLS/.XLSX）、PDF（.pdf/.PDF）、文本文件(.txt/.TXT) 或JPG(.jpg/.JPG)、PNG(.png/.PNG)格式，每个附件大小不能超20M',
    muFileError:
      "附件上传格式为'JPG', 'PNG', 'DOC', 'JPEG', 'DOCX'，所有附件大小不能超2M。",
    fileSize: '您好，您所提交的附件内容为空，请核对后提交，谢谢。',
    fileTip:
      'Please upload the following attachments as needed based on the actual situation:1. Explanation of circumstances 2.Front and back images of ID card or other official identity documents 3. Official proof of travel disruption 4.Official proof of destination activity postponement or cancellation 5.Screenshot of abnormal health code or nucleic acid test result 6.Other official proof of inability to travel due to pandemic-related reasons.',
    fileTipIll:
      'Please upload the medical payment invoice or hospitalization deposit proof issued by a medical institution recognized by China Southern Airlines.',
    fileTipProof:
      '请根据实际情况，按需上传如下附件：<br/>1.本人手持购票证件（姓名页）和抗原检测阳性结果合照，要求本人人脸、姓名页证件和抗原阳性结果须同框。<br/>2.学校放假计划调整证明文件和学生证(封面和姓名页)图片。<br/>3.其他疫情原因导致无法出行的官方证明材料。',
    noRefundMode:
      '抱歉！由于系统操作权限原因，您暂无法办理退票，请您联系原出票地办理退票。',
    thanksPerson: 'Thank you for your support and cooperation!',
    contactInfo:
      'Reminder: Please carefully verify the flight details, passenger name, ID information, and contact number to avoid any issues during your journey.',
    transferInfo:
      '您的客票调整至中转航班后，如已预定附加服务可能无法保障，具体以现场核销为准, ',
    pleaseCheckIsFood: '请您先勾选是否机上用餐',
    fileSuppleTip:
      'You have selected the refund due to illness, but have not uploaded your identification or relevant medical supporting documents. Please provide the required materials before submitting.',
  },
  feeQuery: {
    selectFlight: '请选择想要退票或变更的航段! ',
    refundrules: '您好！根据退改规则，所有未使用航段必须同时申退。',
    canotChange: '您选择的航段不可变更，请重新选择',
    modification: '抱歉，您选择的航段不可变更',
  },
  loginFeeQuery: {
    inputTicketNoOrId: '请输入票号或者证件号！',
    inputName: '请输入旅客姓名！',
    inputTicketNo: '请输入航班号！',
    inputFlightDate: '请选择航班日期！',
  },
  refundChangeCompute: {},
  detailsMessage: {
    inputContactPersonName: '联系人信息很重要，请补充完整',
    inputRightContactPersonName: '请输入正确的联系人姓名',
    inputContactPersonPhone: '联系人信息很重要，请补充完整',
    inputRightContactPersonPhone: '您输入的联系手机不正确，请重新输入',
  },
  realNameVerify: {
    descTitle: '退款账户认证说明',
    descContent:
      '您提交的退票我们将把退款退回您（婴儿请提供携带成人的银行账户）本人的银行账户，请填写有效银联卡并完成认证，退款将在0-20个工作日退回到您提供的银行账户，具体时间以各家银行为准。',
    createRefundTa_error:
      "<div>很抱歉，您的退票遇到问题，请关闭窗口后再次提交或者拔打<a style='display: inline-block;' href='tel:95539 '> <u>95539</u></a>人工服务垂询。</div>",
  },
  ReformProcess: {},
  subInfomation: {
    payOverTime: {
      title: '支付超时',
    },
  },
  ElectronicInvoice: {
    noCompanyName: '请输入公司名称',
    noTaxpayerIdCode: '请输入纳税人识别码',
    noEmail: '请输入收票人邮箱',
    noPhone: '请输入收票人电话',
    erroeEmail: '邮箱输入有误，请重新输入',
    errorTaxpayerIdCode: '纳税人识别号不符合规则',
    errorPhone: '请正确输入收票人电话',
    tip:
      '点击“提交”后将为勾选的乘机人自动填充同样的发票信息并一并提交，请慎重勾选！',
  },
  changeMember: {
    checkMember: '您还没有勾选要入会的乘机人，请先勾选要入会的乘机人',
  },
  rateTip: {
    rateTip: '请选择评分！',
    rateSuccess: '感谢您的反馈！',
  },

  mileageMsg: {
    title(text) {
      return `${text} calculation rule`;
    },
    info(text) {
      return `Calculation formula:<br/>Actual Expired ${text}=Expired ${text} - Extended ${text}<br/>Refunded ${text}=Refundable ${text} - Actual Expired ${text}`;
    },
    btn: '知道了',
  },
  cancelPage: {
    CancellationTip:
      "<p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem; margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem' ><strong style='font-size:0.26rem;color:#009cd9'> 提前了解 </strong><br/> 请在取消行程前留意客票的退改政策，部分客票可能存在不允许变更或退票的规则</p><p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem ;margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem'><strong style='font-size:0.26rem;color:#009cd9'> 无法恢复</strong><br/>取消航班行程后，将无法再乘坐本航班，且无法恢复。</p><p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem;margin:0.1rem 0;text-align:left;color:#262626; font-size:0.2rem'><strong style='font-size:0.26rem;color:#009cd9'> 后续出行</strong><br/>在确定好新的行程后，您可在机票退改模块点击“变更”按钮，预订新的航班。</p>",
  },
  tchan: 'Ticket change',
  trefun: 'Refund Request',
  tchanges: 'Change Request',
  cancelt: '取消行程申请',
  tcu: '退改/升舱',
  gongwu: '公务员信息认证',
  payresun: 'Payment Result',
  yasd: '退款账户认证',
  refundName: 'Details of refund ',
  changeName: 'Details of change',
  refundSeat: '取消行程详情',
  serveC: '餐食服务',
  contact: 'Call ',
  refundSubmitTip1:
    'The system is processing your refund request. Please wait!',
  refundSubmitTip2: 'If submission fails, please try again later.',
  sumitKnow: 'I Understand',
  sumitSure: 'Confirm Submission',
  moreThink: 'Let me think',
  ticInfo: 'Ticket Info',
  lessPrice: function (refundMoney){
    return `Pursuant to the ticket refund policy, the refundable amount for this ticket is low (${refundMoney}). Please confirm whether you wish to proceed with the refund submission.`;
  }
};



// WEBPACK FOOTER //
// ./src/config/commonlang/en.js